var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"cycle-gamap"}},[_c('div',{staticClass:"cycle-gamap-items-container scroll"},_vm._l((_vm.growAreas),function(ga){return _c('div',{key:ga._id,staticClass:"cycle-gamap-items-container-items",style:(_vm.generateDynamicStyle(ga)),on:{"click":() => _vm.handleItemClick(ga)}},[_vm._v(" "+_vm._s(ga.growarea)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }